import script from "./noSavedVehicles.vue?vue&type=script&setup=true&lang=ts"
export * from "./noSavedVehicles.vue?vue&type=script&setup=true&lang=ts"

import "./noSavedVehicles.vue?vue&type=style&index=0&id=2de8d946&scoped=true&lang=scss"

import exportComponent from "C:\\agent\\_work\\1643\\s\\VCLWSAA\\source\\VCLWSAA.Presentation.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de8d946"]])

export default __exports__